export default "__VITE_ASSET__O1GY9gXD__"